import { MiddlewareAPI } from 'types/redux';

export default function prefillConsentAccepted(store: MiddlewareAPI) {
  store.dispatch({
    type: '@@sdk/PREFILL_DATA_REQUESTED'
  });
}
